import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take, switchMap, of, catchError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const redirectToWelcomeOrWebsite = () => {
    if (authService.isCustomerAccountRoute(state.url)) {
      authService.redirectCustomerSessionExpired(state.url);
      return false;
    }
    return router.createUrlTree(['/welcome']);
  };

  return authService.isAuthenticated$.pipe(
    take(1),
    switchMap(isAuth => {
      if (isAuth) {
        return of(true);
      }

      // Attempt a token refresh (we may have a valid refresh cookie from a prior session)
      return authService.refresh({ redirectOnFailure: false }).pipe(
        switchMap(tokenResponse => {
          if (tokenResponse) {
            // After refresh, load the user profile so the shell can render
            return authService.me().pipe(
              map(() => true),
              catchError(() => of(redirectToWelcomeOrWebsite())),
            );
          }
          return of(redirectToWelcomeOrWebsite());
        }),
        catchError(() => of(redirectToWelcomeOrWebsite())),
      );
    }),
  );
};
